// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3JHindRUN-RZ3ZC6vStuFW {\n  z-index: 1000000;\n}\n", ""]);
// Exports
exports.locals = {
	"tooltip": "_3JHindRUN-RZ3ZC6vStuFW"
};
module.exports = exports;
